<app-base-overlay [title]="'Select a location'">
<div body>
    <app-google-address-auto-complete (locationSelected)="onLocationSelected($event)"></app-google-address-auto-complete>
  <div
    class="my-4 relative h-[400px] min-h-[400px] w-full overflow-hidden rounded-lg border border-neutral-200">
    <div
      #mapContainer
      class="absolute inset-0 h-full w-full">
    </div>
    <div
      class="pointer-events-none absolute left-1/2 top-1/2 z-20 -translate-x-1/2 -translate-y-full">

      <svg
        class="h-12 w-12"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xml:space="preserve">
      <g>
        <path
          fill="#9CA3AF"
          d="M256,264.828c-12.359,0-23.834-1.766-34.428-4.414l16.772,233.931
          C239.228,504.055,246.29,512,256,512c9.71,0,16.772-7.945,17.655-17.655
          l16.772-233.931C279.835,263.062,268.359,264.828,256,264.828"/>

        <path
          fill="#16A34A"
          d="M388.414,132.414C388.414,59.145,329.269,0,256,0S123.586,59.145,123.586,132.414
          S182.731,264.828,256,264.828S388.414,205.683,388.414,132.414"/>

        <path
          fill="#4ADE80"
          d="M158.897,141.241c-5.297,0-8.828-3.531-8.828-8.828c0-58.262,47.669-105.931,105.931-105.931
          c5.297,0,8.828,3.531,8.828,8.828s-3.531,8.828-8.828,8.828c-48.552,0-88.276,39.724-88.276,88.276
          C167.724,137.71,164.193,141.241,158.897,141.241"/>
      </g>
    </svg>
    </div>
    <button
      type="button"
      aria-label="Use current location"
      title="Use current location"
      (click)="useCurrentLocation()"
      class="absolute right-4 top-4 z-30 flex h-12 w-12 items-center justify-center rounded-xl bg-white text-neutral-700 shadow-md cursor-pointer"
    >
      <svg
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        id="mdi-crosshairs-gps"
        viewBox="0 0 24 24"
        class="h-6 w-6"
      >
        <path
          d="M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5A7,7 0 0,0 5,12A7,7 0 0,0 12,19A7,7 0 0,0 19,12A7,7 0 0,0 12,5Z"
        />
      </svg>
    </button>

  </div>  @if (selectedLocation(); as location) {
    <div class="rounded-lg border border-neutral-200 bg-neutral-50 px-3">
      <div class="py-2">
        <div class="text-sm font-medium text-neutral-700">
          Selected Location
        </div>
        <div class="mt-1 text-sm text-neutral-900">
          {{ location.address }}
        </div>
        <div class="flex justify-start items-center gap-2 mt-1 text-xs text-neutral-500">
         <p>Latitude:{{ location.latitude.toFixed(6) }},</p>
          <p>Longitude: {{ location.longitude.toFixed(6) }}</p>
        </div>
      </div>
      </div>
  }
</div>
  <div actions>
      <div class="flex items-center justify-end gap-4 py-4">
        <lib-signal-button [appearance]="'outline'" (click)="onCancelClicked()">Cancel</lib-signal-button>
       <lib-signal-button  [type]="'button'" (click)="onConfirmClicked()">Confirm Location</lib-signal-button>
      </div>
  </div>
</app-base-overlay>
